"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MatrixChart = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".c733e1456{padding:1.5625rem;border-radius:.9375rem;background:#fff}.c70e847a6{font-size:1rem;font-weight:500;line-height:1.125rem;color:var(--color-flomni-gray-90);margin-bottom:1.875rem}.ce2c80bee{display:grid;grid-template-columns:calc(((100% - 3.125rem)/ 10) * 8) calc(((100% - 3.125rem)/ 10) * 2);grid-gap:3.125rem;grid-gap:3.125rem;grid-gap:3.125rem;gap:3.125rem}.cbbe2ca2c .ce2c80bee{display:block}.cbbe2ca2c .ce71fc175{display:none}.c069f6e42{display:grid;grid-template-columns:fit-content(100%) 1fr;grid-gap:.25rem;grid-gap:.25rem;grid-gap:.25rem;gap:.25rem}.cd9c60fac .c0c28139f{text-align:right;margin-bottom:.25rem}.cd9c60fac .c0c28139f:last-child{margin-bottom:0}.c0c28139f{white-space:nowrap;text-overflow:ellipsis;overflow:hidden;color:var(--color-flomni-gray-70);font-size:.875rem;font-weight:400;line-height:1rem}.cc62f74f5{display:block;overflow:hidden}.c7784f530{overflow:auto;margin-bottom:1.875rem}.c8950b651{display:grid;grid-gap:.25rem;grid-gap:.25rem;gap:.25rem;grid-gap:.25rem;margin-bottom:.25rem}.ce1c79850{display:grid;grid-gap:.25rem;grid-gap:.25rem;gap:.25rem;grid-gap:.25rem}.ce1c79850 .c0c28139f{text-align:center}.c7c9b9e63{position:relative;z-index:0;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;text-align:center}.c7c9b9e63:after{content:'';position:absolute;top:0;left:0;right:0;bottom:0;z-index:-1;background:var(--color-flomni-blue-70);border-radius:.125rem}.cc714eca9{font-size:.875rem;font-weight:400;line-height:1rem;color:var(--color-flomni-gray-40)}.c92fa27f3{font-size:.875rem;font-weight:500;line-height:1rem;color:var(--color-flomni-gray-90)}.c8b8e6449{font-size:.875rem;font-weight:500;line-height:1rem;color:#fff}.c274b95f7:after{opacity:.1}.c4d8b961f:after{opacity:.2}.c3422a422:after{opacity:.3}.c8cbe6b2e:after{opacity:.4}.c642e9b2b:after{opacity:.5}.cc85ae462:after{opacity:.6}.c7a93c93a:after{opacity:.7}.c080c6e71:after{opacity:.8}.cc2bd04c4:after{opacity:.9}.cc2c2805b:after{opacity:1}.ce71fc175{display:block}.c6aa1b286{font-size:.875rem;font-weight:400;line-height:1.25rem;color:var(--color-flomni-gray-90);margin-bottom:.9375rem}.c6aa1b286:last-child{margin-bottom:0}.cc3f89b9e{display:block}.c381eea05{display:grid;grid-template-columns:repeat(4,calc((100% - .25rem * 3)/ 4));grid-gap:.25rem;grid-gap:.25rem;gap:.25rem;grid-gap:.25rem;padding-bottom:calc(.3125rem + 1rem)}.c66232007{height:.9375rem;position:relative}.c66232007:first-child:before{font-size:.875rem;font-weight:400;line-height:1rem;content:'0';position:absolute;color:var(--color-flomni-gray-70);top:100%;padding-top:.3125rem}.c66232007:last-child .c51c7ccd8{-webkit-transform:none;transform:none}.c51c7ccd8{font-size:.875rem;font-weight:400;line-height:1rem;padding-top:.3125rem;position:absolute;color:var(--color-flomni-gray-70);top:100%;right:0;-webkit-transform:translate(calc(50% + .125rem),0);transform:translate(calc(50% + .125rem),0)}.c08bc6a49{background:var(--color-flomni-blue-70);border-radius:.125rem;position:absolute;top:0;left:0;right:0;bottom:0}.c6348faa4 .c0c28139f{padding:.4375rem}.c6348faa4 .c7c9b9e63{padding:.4375rem}.c7d546c0e .c0c28139f{padding:.125rem .4375rem;height:1.25rem;box-sizing:border-box}.c7d546c0e .c7c9b9e63{height:1.25rem}");
var styles = {
  root: 'c733e1456',
  title: 'c70e847a6',
  '-webkit-columns': 'ce2c80bee',
  columns: 'ce2c80bee',
  '--no-legend': 'cbbe2ca2c',
  legends: 'ce71fc175',
  chart: 'c069f6e42',
  'axis-y': 'cd9c60fac',
  label: 'c0c28139f',
  data: 'cc62f74f5',
  table: 'c7784f530',
  cells: 'c8950b651',
  'axis-x': 'ce1c79850',
  'cell-general': 'c7c9b9e63',
  '--cell-first': 'cc714eca9',
  '--cell-second': 'c92fa27f3',
  '--cell-third': 'c8b8e6449',
  '--opacity-1': 'c274b95f7',
  '--opacity-2': 'c4d8b961f',
  '--opacity-3': 'c3422a422',
  '--opacity-4': 'c8cbe6b2e',
  '--opacity-5': 'c642e9b2b',
  '--opacity-6': 'cc85ae462',
  '--opacity-7': 'c7a93c93a',
  '--opacity-8': 'c080c6e71',
  '--opacity-9': 'cc2bd04c4',
  '--opacity-10': 'cc2c2805b',
  legend: 'c6aa1b286',
  scale: 'cc3f89b9e',
  thermometer: 'c381eea05',
  color: 'c66232007',
  degree: 'c51c7ccd8',
  bg: 'c08bc6a49',
  '--view-usual': 'c6348faa4',
  '--view-short': 'c7d546c0e'
};

var MatrixChart = function MatrixChart(props) {
  var classes = props.classes,
      labelsX = props.labelsX,
      legends = props.legends,
      labelsY = props.labelsY,
      data = props.data,
      title = props.title,
      view = props.view;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useMemo = (0, _react.useMemo)(function () {
    return {
      yLength: labelsY.length,
      xLength: labelsX.length
    };
  }, [labelsX.length, labelsY.length]),
      yLength = _useMemo.yLength,
      xLength = _useMemo.xLength;

  var totalMax = (0, _react.useMemo)(function () {
    return Math.max.apply(Math, (0, _toConsumableArray2.default)(data.map(function (item) {
      return item.value;
    })));
  }, [data]);
  var matrix = (0, _react.useMemo)(function () {
    var matrix = Array(yLength).fill(null).map(function () {
      return Array(xLength).fill(null);
    });
    matrix.forEach(function (row, rowIndex) {
      var y = labelsY[rowIndex];
      var max = view === 'usual' ? data.filter(function (item) {
        return item.y === y;
      }).map(function (item) {
        return item.value;
      }).reduce(function (result, value) {
        return result + value;
      }, 0) : totalMax;
      var min = 0;
      row.forEach(function (cell, cellIndex) {
        var x = labelsX[cellIndex];
        var found = data.find(function (item) {
          return item.x === x && item.y === y;
        });
        var value = found ? found.value : 0;
        var nMax = 10;
        var nMin = 1;
        var opacity = max === 0 ? nMin : Math.round((value - min) * (nMax - nMin) / (max - min) + nMin);
        var type = value === 0 ? 'first' : value < max / 2 ? 'second' : 'third';
        row[cellIndex] = {
          value: value,
          opacity: opacity,
          type: type
        };
      });
    });
    return matrix;
  }, [data, labelsX, labelsY, totalMax, view, xLength, yLength]);
  var scale = (0, _react.useMemo)(function () {
    var termometrData = [0.1, 0.4, 0.7, 1];
    return termometrData.map(function (item, index) {
      var result = view === 'usual' ? "".concat(100 / termometrData.length * (index + 1), "%") : Math.round(totalMax / termometrData.length * (index + 1) * 100 / 100);
      return {
        opacity: item,
        value: result
      };
    });
  }, [totalMax, view]);
  var gridTemplateColumns = (0, _react.useMemo)(function () {
    return "repeat(".concat(xLength, ", minmax(3rem, calc((100% - 0.25rem * ").concat(xLength - 1, ") / ").concat(xLength, ")))");
  }, [xLength]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.root, cn.view[view], (0, _defineProperty2.default)({}, cn.no.legend, view === 'short' || !legends.length))
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.title
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.columns
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.chart
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.axis.y
  }, labelsY.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: cn.label
    }, item);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.data
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.table
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.cells,
    style: {
      gridTemplateColumns: gridTemplateColumns
    }
  }, matrix.reduce(function (result, row, rowIndex) {
    row.forEach(function (cell, cellIndex) {
      var _classNames2;

      result.push( /*#__PURE__*/_react.default.createElement("div", {
        key: "row-".concat(rowIndex, "cell-").concat(cellIndex),
        className: (0, _classnames.default)(cn.cell.general, cn.opacity["".concat(cell.opacity)], (_classNames2 = {}, (0, _defineProperty2.default)(_classNames2, cn.cell.first, cell.type === 'first'), (0, _defineProperty2.default)(_classNames2, cn.cell.second, cell.type === 'second'), (0, _defineProperty2.default)(_classNames2, cn.cell.third, cell.type === 'third'), _classNames2)),
        title: view !== 'short' && cell.value ? cell.value : null
      }, view !== 'short' ? cell.value : null));
    });
    return result;
  }, [])), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.axis.x,
    style: {
      gridTemplateColumns: gridTemplateColumns
    }
  }, labelsX.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      key: index,
      className: cn.label
    }, item);
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.scale
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.thermometer
  }, scale.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: cn.color,
      key: index
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: cn.bg,
      style: {
        opacity: item.opacity
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: cn.degree
    }, item.value));
  }))))), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.legends
  }, legends.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: cn.legend,
      key: index
    }, item);
  }))));
};

exports.MatrixChart = MatrixChart;
var view = ['usual', 'short'];
MatrixChart.modes = {
  view: view
};
MatrixChart.propTypes = {
  /* component logic props */
  legends: (0, _propTypes.arrayOf)(_propTypes.node),
  labelsX: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  labelsY: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  data: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    x: _propTypes.string.isRequired,
    y: _propTypes.string.isRequired,
    value: _propTypes.number.isRequired
  })).isRequired,
  title: _propTypes.node.isRequired,
  view: (0, _propTypes.oneOf)(view),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
MatrixChart.defaultProps = {
  view: 'usual',
  classes: {},
  legends: []
};